// extracted by mini-css-extract-plugin
export default {"overlay":"Cookies_overlay__5F7j4","hidden":"Cookies_hidden__vZ-z8","wrap":"Cookies_wrap__SvDLZ","btn":"Cookies_btn__+biEJ"};